module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/69e164fac0cca66c053ecb31c9c2aa64.png";